// Unused or unreferenced check for delete
import { supabase } from './supabase'
import type { QuizQuestion, UserTraits } from '@/types/quiz'

export async function fetchQuizQuestions(): Promise<QuizQuestion[] | null> {
  const { data, error } = await supabase
    .from('quiz_questions')
    .select(`
      *,
      options:quiz_options(*)
    `)
    .eq('active', true)

  if (error) {
    console.error('Error fetching quiz questions:', error)
    return null
  }

  if (!data?.length) {
    console.warn('No quiz questions found')
    return null
  }

  return data
}

export async function saveUserPreferences(
  userId: string,
  traits: UserTraits
): Promise<void> {
  const { error } = await supabase
    .from('user_preferences')
    .upsert({
      user_id: userId,
      traits
    })

  if (error) throw error
}

export async function createQuizQuestion(
  question: Partial<QuizQuestion>
): Promise<string> {
  // First insert the question
  const { data: questionData, error: questionError } = await supabase
    .from('quiz_questions')
    .insert({
      question: question.question,
      description: question.description,
      category: question.category,
      active: question.active
    })
    .select()
    .single()

  if (questionError) throw questionError

  // Then insert all options
  const options = question.options?.map(option => ({
    ...option,
    question_id: questionData.id
  }))

  const { error: optionsError } = await supabase
    .from('quiz_options')
    .insert(options)

  if (optionsError) throw optionsError

  return questionData.id
}

export async function updateQuizQuestion(
  id: string,
  question: Partial<QuizQuestion>
): Promise<void> {
  // Update the question
  const { error: questionError } = await supabase
    .from('quiz_questions')
    .update({
      question: question.question,
      description: question.description,
      category: question.category,
      active: question.active
    })
    .eq('id', id)

  if (questionError) throw questionError

  // Delete existing options
  const { error: deleteError } = await supabase
    .from('quiz_options')
    .delete()
    .eq('question_id', id)

  if (deleteError) throw deleteError

  // Insert new options
  const options = question.options?.map(option => ({
    ...option,
    question_id: id
  }))

  const { error: optionsError } = await supabase
    .from('quiz_options')
    .insert(options)

  if (optionsError) throw optionsError
}

export function calculateTraits(
  currentTraits: UserTraits,
  selectedTraits: string[]
): UserTraits {
  const updatedTraits = { ...currentTraits }

  selectedTraits.forEach(trait => {
    const [category, value] = trait.split(':')
    if (!updatedTraits[category]) {
      updatedTraits[category] = {}
    }
    updatedTraits[category][value] = (updatedTraits[category][value] || 0) + 1
  })

  return updatedTraits
}